import axios from "axios";
import { useEffect, useState } from "react";
import { G_API } from "../../constants/globalVar";
import PageSlider from "../PageSlider";
import {
  BsCalendar2EventFill,
  BsDatabaseFill,
  BsFillSendFill,
  BsPieChartFill,
} from "react-icons/bs";
import PlaceholderPostVertical from "../Placeholders/PlaceholderPostVertical";
import AllEvents from "../AllEvents";
import FAQ from "../FAQ";
import DummyBanner from "../DummyBanner";

const AdmissionsPage = () => {
  // Dynamic API State
  const [applySection, setApplySection] = useState(null);
  const [tutionSection, setTutionSection] = useState(null);
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [faqs, setFaqs] = useState([]);

  const [admissionEvents, setAdmissionEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch Sections (How to Apply & Tuition)
  const fetchSections = async () => {
    try {
      const res = await axios.get(`${G_API}sections?type=admission`);
      const data = res.data.DATAS;
      // Find specific sections by key
      setApplySection(data.find(s => s.section_key === 'how_to_apply'));
      setTutionSection(data.find(s => s.section_key === 'tution_fee_info'));
    } catch (err) { console.error("Section Error:", err); }
  };

  // Fetch Tabs
  const fetchTabs = async () => {
    try {
      const res = await axios.get(`${G_API}tabs`);
      setTabs(res.data.DATAS);
      if (res.data.DATAS.length > 0) setActiveTab(res.data.DATAS[0]);
    } catch (err) { 
      console.error("Tab Error:", err); 
    }
  };

  // Fetch FAQs
  const fetchFaqs = async () => {
    try {
      const res = await axios.get(`${G_API}faqs?active=true`);
      setFaqs(res.data.DATAS);
    } catch (err) { console.error("FAQ Error:", err); }
  };

  const fetchEvents = async (page = 1) => {
    axios.post(`${G_API}events/EVENT_LIST`, {
      page: page,
      limit: 5,
      admission_only: true,
    })
      .then((response) => {
        const items = response.data.DATAS || [];

        setAdmissionEvents(items);
      })
      .catch((error) => {
        console.error("Error fetching events:", error);
      });
  };

  useEffect(() => {
    fetchEvents();
    fetchSections();
    fetchTabs();
    fetchFaqs();
    setIsLoading(false);
  }, []);

  const defaultImage = G_API + "uploads/ahnyar-logo.png";

  return (
    <>
      <DummyBanner />
      <section id="sliders">
        <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            <PageSlider inputType="admissions" />
          </div>
        </div>

        {/* Top menu links */}
        <div className="container">
          <div className="mx-auto fw-bold rounded-4 p-4 p-md-5" style={{ marginTop: "-80px", position: "relative", zIndex: 10, backgroundColor: "#FFFFFF", color: "#14499A", boxShadow: "0 10px 30px rgba(0,0,0,0.1)" }}>
            <div className="row g-4 justify-content-center">
              {[
                { key: "how-to-apply", icon: <BsFillSendFill size={24} />, label: "How to Apply" },
                { key: "tution-fee", icon: <BsDatabaseFill size={24} />, label: "Tuition & Fees" },
                { key: "calendar", icon: <BsCalendar2EventFill size={24} />, label: "Academic Calendar" },
                { key: "overview-tabs", icon: <BsPieChartFill size={24} />, label: "Overview" },
              ].map((item, index) => (
                <div key={index} className="col-6 col-md-3">
                  <a href={"#" + item.key} className="text-decoration-none">
                    <div className="d-flex flex-column align-items-center text-center gap-3 transition-all hover-scale" style={{ cursor: "pointer" }}>
                      <div className="p-3 rounded-circle bg-light text-primary mb-1">{item.icon}</div>
                      <span style={{ fontSize: "0.95rem", lineHeight: "1.2" }}>{item.label}</span>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* How to apply - Dynamic from Section API */}
      {applySection && (
        <section id="tution-fee" style={{ backgroundColor: applySection.bg_color || "#C8F5E1" }} className="py-5">
          <div className="container py-5">
            <div
              className={`row g-5 align-items-center d-flex ${applySection.image_side === "left"
                  ? "flex-row-reverse"
                  : "flex-row"
                } `}
            >
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                <div className="h-100">
                  <h1 className="display-6 mb-2">{applySection.title}</h1>

                  {applySection.subtitle && (
                    <h4 className="mb-4 opacity-75" style={{ color: "#111110" }}>
                      {applySection.subtitle}
                    </h4>
                  )}
                  <div
                    className="mb-4"
                    dangerouslySetInnerHTML={{
                      __html: applySection.content,
                    }}
                  />
                  {(applySection.action_url && applySection.action_url !== 'null' && applySection.action_url !== 'undefined') && (
                    <a
                      className="btn btn-outline-primary py-2 px-4 fw-normal rounded-5 animated slideInDown"
                      href={applySection.action_url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {applySection.action_label || "Read More"}
                    </a>
                  )}
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <div
                  className="position-relative overflow-hidden h-100 rounded-4 shadow-sm"
                  style={{ minHeight: "400px", maxHeight: "400px" }}
                >
                  <img
                    className="position-absolute w-100 h-100"
                    src={applySection.admission_img.src || defaultImage}
                    alt={applySection.title}
                    style={{
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Overview Tabs */}
      {(tabs && (tabs?.length > 0)) && (
        <section id="overview-tabs">
          <div className="my-5 py-5">
            <div className="container py-5">
              <ul className="nav nav-underline mb-3">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab._id}>
                    <button
                      className={`nav-link text-muted border-0 bg-transparent ${activeTab?._id === tab._id ? 'active text-decoration-underline' : ''}`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab.tab_label}
                    </button>
                  </li>
                ))}
              </ul>
              {activeTab && (
                <div className="py-2">
                  <div dangerouslySetInnerHTML={{ __html: activeTab.content_body }} />
                </div>
              )}
            </div>
          </div>
        </section>
      )}

      {/* Tution Fee */}
      {tutionSection && (
        <section id="tution-fee" style={{ backgroundColor: tutionSection.bg_color || "#C8F5E1" }} className="py-5">
          <div className="container py-5">
            <div
              className={`row g-5 align-items-center d-flex ${tutionSection.image_side === "left"
                  ? "flex-row-reverse"
                  : "flex-row"
                } `}
            >
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                <div className="h-100">
                  <h1 className="display-6 mb-2">{tutionSection.title}</h1>

                  {tutionSection.subtitle && (
                    <h4 className="mb-4 opacity-75" style={{ color: "#111110" }}>
                      {tutionSection.subtitle}
                    </h4>
                  )}
                  <div
                    className="mb-4"
                    dangerouslySetInnerHTML={{
                      __html: tutionSection.content,
                    }}
                  />
                  {(tutionSection.action_url && tutionSection.action_url !== 'null' && tutionSection.action_url !== 'undefined') && (
                    <a
                      className="btn btn-outline-primary py-2 px-4 fw-normal rounded-5 animated slideInDown"
                      href={tutionSection.action_url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {tutionSection.action_label || "Read More"}
                    </a>
                  )}
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <div
                  className="position-relative overflow-hidden h-100 rounded-4 shadow-sm"
                  style={{ minHeight: "400px", maxHeight: "400px" }}
                >
                  <img
                    className="position-absolute w-100 h-100"
                    src={tutionSection.admission_img.src || defaultImage}
                    alt={tutionSection.title}
                    style={{
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Events Calendar */}
      {admissionEvents.length > 0 && (
        <section id="calendar">
          <div className="py-5 bg-light">
            <div className="container py-5">
              <div
                className="text-center mx-auto mb-5 wow fadeInUp"
                data-wow-delay="0.1s"
                style={{ maxWidth: "500px" }}
              >
                <div className="d-inline-block rounded-pill bg-important text-important py-1 px-3 mb-3">Events</div>
                <h1 className="display-6 mb-1">Academic Calendar</h1>
                <p className="mb-5">Explore the events related to admissions</p>
              </div>
              <div>
                {isLoading ? (
                  <PlaceholderPostVertical />
                ) : (
                  <div className="d-flex flex-row justify-content-start gap-3 flex-wrap">
                    {admissionEvents.map((item) => (
                      <AllEvents
                        key={item.id}
                        item={item}
                        horizontal={true}
                        style={{
                          width: "250px",
                          margin: "20px",
                          textAlign: "center",
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* FAQ - Dynamic from FAQ API */}
      {faqs && (<FAQ faqData={faqs.map(f => ({ question: f.question, answer: f.answer }))} />)}

      <style>{`
        .hover-scale { transition: transform 0.2s ease; }
        .hover-scale:hover { transform: translateY(-5px); color: #0d6efd; }
        .nav-link.active { font-weight: bold; color: #0d6efd !timportant; }
      `}</style>
    </>
  );
};

export default AdmissionsPage;